import React from 'react';

import '../dashboard.scss';

export default (props) => {
  return (
    <div className='defaultSection' style={{height: props.height}}>
      <div className="sectionTitle">{props.title}</div>
      {props.children}
    </div>
  )
}
